import { serviceState } from './state';

function getTenantId(tenantId: number, agentId?: string): string {
  // make sure the tenant id is valid if it's for the current user, returns an empty if the tenant id is not valid.
  // in cases where a user call into a queue directly it will not have a tenant id, so we need to return an empty string.
  if (
    agentId &&
    agentId === serviceState.contactCenterUserId &&
    !serviceState.tenantIds.find((id) => id === tenantId.toString())
  ) {
    return '';
  }
  return tenantId.toString();
}

export default getTenantId;
